import "./styles/Hero.css";

const Hero = () => {
  return (
    <div className="hero">
      <h1>克雷斯電子書</h1>
      <h1>孩子的數位學習知識庫</h1>
      <img src="/Assets/landing/hero.png" alt="" />
    </div>
  );
};

export default Hero;
